"use strict";

let jsErrorHandling_ErrorArr;

function EncompassErrorHandler(message, fileURL, lineNum, columnNum, error) {
    if (message instanceof ErrorEvent) {
        fileURL = message.filename;
        lineNum = message.lineno;
        columnNum = message.colno;
        error = message.error;
        message = message.message;
    }
    message = EC_Fmt.Null2EmptyStr(message);
    if (!EC_Fmt.isNull(fileURL) && fileURL.toLowerCase().indexOf("jquery.js") === -1 && (fileURL.indexOf("GlobalDocs/") !== -1) && message.indexOf("nsIDOMWindowInternal.alert") === -1) {
        if (message.startsWith("Error in promise - ")) {
            message = message.slice(19);
        }

        if ((fileURL === "UnknownFile" || fileURL === "UnknownFile") && EC_Fmt && typeof EC_Fmt.GetPageParameter === "function" && EC_Fmt.GetPageParameter("DashboardID")) {
            fileURL = `DashboardID=${EC_Fmt.GetPageParameter("DashboardID")}`;
        }

        // Task 744054: SystemError: TaskEdit.aspx?Action=Add ResizeObserver loop limit exceeded
        // Task 722392: Encompass ID: Wyliq System error:JavaScript Error: UnknownFile (0) - Error in promise - TypeError: NetworkError when attempting to fetch resource.
        // Task 952720: JavaScript Error: DashboardID=156941 (0) - AbortError: The operation was aborted.
        // Task 953074: JavaScript Error: DashboardID=156940 (0) - Object Not Found Matching Id:1
        // Task 954907: System Error:JavaScript Error: DashboardID=168087 (0) - Object Not Found Matching Id:2
        // Task 932152: SystemError: GetOAuthID. The remote server returned an error: (403) Forbidden.
        // Task 948452: System Error:JavaScript Error: DashboardID=178892 (0) - :
        const KnownErrorsFromExtensions = ["removeNightMode is not defined", "extAbbr is not defined", "ResizeObserver loop limit exceeded", "NetworkError when attempting to fetch resource", "TypeError: Failed to fetch", "AbortError: The operation was aborted", "TypeError: The network connection was lost", "Object Not Found Matching Id", "TypeError: cancelled", "GetOAuthID. The remote server returned an error: (403) Forbidden.", "EC_Request: Failed to request"];
        let isKnownErrorFromExtension = false;

        for (let i = 0; i < KnownErrorsFromExtensions.length; i++) {
            if (message.indexOf(KnownErrorsFromExtensions[i]) !== -1) {
                isKnownErrorFromExtension = true;
            }
        }

        if (!window.navigator.onLine) {
            if (BC_EWS) {
                if (!BC_EWS.NoInternetDialog && !BC_EWS.NoInternetDialogInterval) {
                    clearInterval(BC_EWS.NoInternetDialogInterval);
                    BC_EWS.NoInternetDialog = ECP.Dialog.Alert("No Internet Connection");
                    BC_EWS.NoInternetDialogInterval = setInterval(() => {
                        if (navigator.onLine) {
                            // Task 713357: Javascript error: Failed to execute 'removeChild' on 'Node': parameter 1 is not of type 'Node'.
                            if (BC_EWS.NoInternetDialog && typeof BC_EWS.NoInternetDialog.remove === "function") {
                                BC_EWS.NoInternetDialog.remove();
                                BC_EWS.NoInternetDialog = undefined;
                            }
                            clearInterval(BC_EWS.NoInternetDialogInterval);
                        }
                    }, 1000);
                }
            } else {
                // eslint-disable-next-line no-alert
                alert("Internet Connection Lost");
            }
        } else if (!isKnownErrorFromExtension) {
            // Task 951060: Lots of duplicate system errors if the user makes a mistake in a code block
            if (!jsErrorHandling_ErrorArr) {
                jsErrorHandling_ErrorArr = [];
            }
            if (jsErrorHandling_ErrorArr.indexOf(message) === -1) {
                jsErrorHandling_ErrorArr.push(message);

                let CurDomain = "";

                try {
                    CurDomain = fileURL.split(/\/+/g)[1];
                } catch (e) {
                    // ignore this error
                }

                let stack = error ? error.stack : "Error details not received at EncompassErrorHandler()";

                if (fileURL.indexOf(".js?v=") !== -1) {
                    const version = fileURL.substring(fileURL.indexOf(".js?v=") + 3);
                    fileURL = fileURL.replace(version, ""); // Remove the '?v=....' at the end
                    stack = EC_Fmt.ReplaceAll(stack, version, "");
                }

                stack = EC_Fmt.ReplaceAll(EC_Fmt.ReplaceAll(stack, `http://${CurDomain}/`, "/"), `https://${CurDomain}/`, "/");

                // Task 667196: Convert JSErrorHandler.aspx to an API Command
                // Task 1064057: Use EC_ Request replace fetch
                const myRequest = new ECP.EC_Request("DevOps_JSErrorHandler");
                myRequest.SetReturnType(ECP.EC_ReturnType.Text);
                myRequest.AddRequestVariable("Error", message, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("Domain", CurDomain, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("File", fileURL, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("Line", lineNum, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("Column", columnNum, ECP.EC_Verb.Post);
                myRequest.AddRequestVariable("Stack", stack, ECP.EC_Verb.Post);
                myRequest.Submit().then(() => {
                    if (message.indexOf("<html><head><title>System Error</title>") === -1) {
                        // eslint-disable-next-line no-alert
                        alert(message);
                    } else {
                        // Task 657850: Find a way to get a better looking error when javascript receives HTML data from the server due to a System Error
                        const MainLayout = document.getElementById("MainLayout");

                        if (ECP && ECP.Dialog && message.indexOf("</head><body") !== -1 && message.indexOf("</body>") !== -1) {
                            ECP.Dialog.ShowDialog("Error", message.substring(message.indexOf("</head><body") + 7, message.indexOf("</body>")), {
                                width: 600,
                                height: 300,
                                confirmButtonTitle: EC_Fmt.Trn("Continue")
                            });
                        } else if (MainLayout) {
                            MainLayout.innerHTML = message.substring(message.indexOf("<html><head><title>System Error</title>") + 39, message.indexOf("</body></html>"));
                        } else {
                            document.open();
                            document.write(message.substring(message.indexOf("<html><head><title>System Error</title>")));
                            document.close();
                        }
                        if (ECP && ECP.Dialog) {
                            setInterval(() => {
                                ECP.Dialog.HideLoading();
                            }, 1000);
                        }
                    }
                }).catch((postError) => {
                    // eslint-disable-next-line no-alert
                    alert(postError);
                });
            }
        }
    }
}

window.addEventListener("error", EncompassErrorHandler);

window.addEventListener("unhandledrejection", (event) => {
    EncompassErrorHandler(event.reason, "UnknownFile", 0, 0, event.reason);
});
